import { useParams } from "react-router-dom";
import CrudSection from "../../components/carer-essentials/CrudSection";
import ExpiriesRenewals from "./ExpiriesRenewals";
import { SECTION_CONFIG } from "../../data/carerEssentialsSections";

// Note: the single Pro Carer Circle promo for this workspace lives only on
// the Carer Essentials dashboard (CarerEssentialsHub) — deliberately not
// repeated here on every section page, to keep it to one tasteful surface.
export default function CarerEssentialsSectionPage() {
  const { section } = useParams();

  if (section === "expiries") return <ExpiriesRenewals />;

  const config = SECTION_CONFIG[section];
  if (!config) {
    return (
      <div className="container-jcc py-16 text-center" data-testid="ce-section-not-found">
        <p className="text-ink-muted">This Carer Essentials section doesn&rsquo;t exist.</p>
      </div>
    );
  }
  return <CrudSection config={config} />;
}
